"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _luckyWheelApi = require("@/api/luckyWheelApi");
var _customerOrderApi = require("@/api/customerOrderApi");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var PRIZE_STATUS_TAG = {
  0: 'info',
  1: 'warning',
  2: 'success',
  3: 'warning',
  4: '',
  5: 'success',
  6: 'info'
};
var defaultQuery = function defaultQuery() {
  return {
    keyword: '',
    prizeType: '',
    result: '',
    customerId: '',
    prizeStatus: ''
  };
};
var mapEnumOptions = function mapEnumOptions(list) {
  return (Array.isArray(list) ? list : []).map(function (item) {
    return {
      label: item.value,
      value: item.code
    };
  }).filter(function (item) {
    return item.label != null && item.value != null;
  });
};
var _default = exports.default = {
  name: 'LuckyWheelRecord',
  data: function data() {
    return {
      listLoading: false,
      customerLoading: false,
      query: defaultQuery(),
      customerOptions: [],
      tableData: [],
      total: 0,
      pageData: {
        page: 1,
        limit: 10
      },
      prizeTypeOptions: [],
      resultOptions: [],
      prizeStatusOptions: []
    };
  },
  created: function created() {
    this.loadFilterEnums();
    this.searchCustomerOptions('');
    this.fetchList();
  },
  methods: {
    prizeStatusTagType: function prizeStatusTagType(status) {
      var n = Number(status);
      return PRIZE_STATUS_TAG[n] != null ? PRIZE_STATUS_TAG[n] : 'info';
    },
    prizeContentLines: function prizeContentLines(row) {
      var text = row && row.prizeContent != null ? String(row.prizeContent).trim() : '';
      if (!text) return ['—'];
      return text.split(/\n/).filter(function (line) {
        return line !== '';
      });
    },
    loadFilterEnums: function () {
      var _loadFilterEnums = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$Promise$all, _yield$Promise$all2, prizeTypes, results, prizeStatuses;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return Promise.all([(0, _luckyWheelApi.luckyWheelPrizeTypeListApi)().catch(function () {
                return [];
              }), (0, _luckyWheelApi.luckyWheelRecordResultListApi)().catch(function () {
                return [];
              }), (0, _luckyWheelApi.luckyWheelRecordPrizeStatusListApi)().catch(function () {
                return [];
              })]);
            case 1:
              _yield$Promise$all = _context.v;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
              prizeTypes = _yield$Promise$all2[0];
              results = _yield$Promise$all2[1];
              prizeStatuses = _yield$Promise$all2[2];
              this.prizeTypeOptions = mapEnumOptions(prizeTypes);
              this.resultOptions = mapEnumOptions(results);
              this.prizeStatusOptions = mapEnumOptions(prizeStatuses);
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function loadFilterEnums() {
        return _loadFilterEnums.apply(this, arguments);
      }
      return loadFilterEnums;
    }(),
    searchCustomerOptions: function () {
      var _searchCustomerOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(keyword) {
        var res, list, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.customerLoading = true;
              _context2.p = 1;
              _context2.n = 2;
              return (0, _customerOrderApi.companyappAutoListApi)({
                keyword: keyword || ''
              });
            case 2:
              res = _context2.v;
              list = Array.isArray(res) ? res : [];
              this.customerOptions = list.map(function (item) {
                var customerId = item.customerId != null ? Number(item.customerId) : Number(item.id);
                if (!Number.isInteger(customerId) || customerId <= 0) return null;
                return {
                  customerId: customerId,
                  appName: item.appName || item.customerName || item.name || String(customerId)
                };
              }).filter(Boolean);
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              this.customerOptions = [];
            case 4:
              _context2.p = 4;
              this.customerLoading = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3, 4, 5]]);
      }));
      function searchCustomerOptions(_x) {
        return _searchCustomerOptions.apply(this, arguments);
      }
      return searchCustomerOptions;
    }(),
    buildListParams: function buildListParams() {
      var params = {
        page: this.pageData.page,
        limit: this.pageData.limit
      };
      var kw = (this.query.keyword || '').trim();
      if (kw) params.keyword = kw;
      if (this.query.prizeType !== '' && this.query.prizeType != null) params.prizeType = Number(this.query.prizeType);
      if (this.query.result !== '' && this.query.result != null) params.result = Number(this.query.result);
      if (this.query.customerId !== '' && this.query.customerId != null) params.customerId = Number(this.query.customerId);
      if (this.query.prizeStatus !== '' && this.query.prizeStatus != null) params.prizeStatus = Number(this.query.prizeStatus);
      return params;
    },
    fetchList: function () {
      var _fetchList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var data, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.listLoading = true;
              _context3.p = 1;
              _context3.n = 2;
              return (0, _luckyWheelApi.luckyWheelRecordPageApi)(this.buildListParams());
            case 2:
              data = _context3.v;
              this.tableData = data && data.list || [];
              this.total = data && data.total != null ? Number(data.total) : 0;
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t2 = _context3.v;
              this.tableData = [];
              this.total = 0;
            case 4:
              _context3.p = 4;
              this.listLoading = false;
              return _context3.f(4);
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 3, 4, 5]]);
      }));
      function fetchList() {
        return _fetchList.apply(this, arguments);
      }
      return fetchList;
    }(),
    handleSearch: function handleSearch() {
      this.pageData.page = 1;
      this.fetchList();
    },
    handleReset: function handleReset() {
      this.query = defaultQuery();
      this.pageData.page = 1;
      this.searchCustomerOptions('');
      this.fetchList();
    },
    handlePageChange: function handlePageChange(page) {
      this.pageData.page = page;
      this.fetchList();
    },
    handleSizeChange: function handleSizeChange(limit) {
      this.pageData.limit = limit;
      this.pageData.page = 1;
      this.fetchList();
    }
  }
};